import { Cookies } from 'quasar'

const TokenKey = 'admin-token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token: string) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function calculatePasswordScore (password: string): number {
  let score = 0
  if (!password) return score

  // Award every unique letter until 5 repetitions
  const letters = {}
  for (let i = 0; i < password.length; i++) {

    letters[password[i]] = (letters[password[i]] as number || 0) + 1
    score += 5.0 / letters[password[i]]
  }

  // Bonus points for mixing it up
  const variations = {
    digits: /\d/.test(password),
    lower: /[a-z]/.test(password),
    upper: /[A-Z]/.test(password),
    nonWords: /\W/.test(password)
  }

  let variationCount = 0
  for (const check in variations) {
    variationCount += variations[check] === true ? 1 : 0
  }
  score += (variationCount - 1) * 10
  return score
}
